const createAdminRouter = (routerName: string) => {
    return {
        name: 'admin/' + routerName,
        list: '/admin/' + routerName + '/list',
        add: '/admin/' + routerName + '/add',
        edit: '/admin/' + routerName + '/edit/:id',
        detail: '/admin/' + routerName + '/detail/:id',
    }
}

export default {
    public: {
    },
    // Admin
    user: {
        name: 'admin/user',
        list: '/admin/user/list',
        add: '/admin/user/add',
        edit: '/admin/user/edit/:id',
        detail: '/admin/user/detail/:id',
        changePWD: '/admin/user/doi-mat-khau'
    },
    menu: createAdminRouter('menu'),
    roleGroup: {
        ...createAdminRouter('role-group'),
        bulkChucNang: '/admin/role-group/bulk-chuc-nang',
    },
    duAn: createAdminRouter('du-an'),
    chiNhanh: createAdminRouter('chi-nhanh'),
    khoVatLy: createAdminRouter('kho-vat-ly'),
    copyRoleAssignment: {
        name: 'copy-role-assignment',
        copy: '/copy-role-assignment/copy',
    },

    billOfLadingCode: {
        name: 'bill-of-lading-code',
        add: '/bill-of-lading-code/add',
        edit: '/bill-of-lading-code/edit/:id',
        list: '/bill-of-lading-code/list',
        import: '/bill-of-lading-code/import',
    },
    categorie: createAdminRouter('categorie'),
    pricing: createAdminRouter('pricing'),
    pricingConfirm: createAdminRouter('pricing-confirm'),
}
